import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import type { SxProps, Theme } from '@mui/material/styles';

const radioSx: SxProps<Theme> = {
    /** 未选中：图标-按钮 / 主题色-300 */
    color: 'var(--icon-primary-300)',
    '&.Mui-checked': {
        color: (theme) => theme.palette.primary.main,
    },
};

type Props = {
    title?: string;
    radioGroup: { label: string; value: string | number }[];
    value: string | number;
    handleChange: (value: string) => void;
    row?: boolean;
    className?: string;
};

type State = Record<string, never>;

/**
 * 单选组（RBP2 迁入，供打印基础设置等页使用）。
 */
export default class RadioButtonsGroup extends React.Component<Props, State> {
    render() {
        const { title, value, handleChange, radioGroup, row, className } = this.props;
        return (
            <FormControl component="fieldset" className={className || ''}>
                {title ? <FormLabel component="legend">{title}</FormLabel> : null}
                <RadioGroup value={value} row={row} onChange={(e) => handleChange(e.target.value)}>
                    {(radioGroup || []).map((item, index) => (
                        <FormControlLabel
                            key={index}
                            value={item.value}
                            control={<Radio sx={radioSx} />}
                            label={item.label}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        );
    }
}
